import React, { useState, useEffect, useRef } from "react";
import "./css/Home.css";
// import homeimg from "../components/assets/mainFrame.png";
import mobileAtm from "../components/assets/1.gif";
import hrPartner from "../components/assets/2.gif";
import funds from "../components/assets/3.gif";
import payroll from "../components/assets/4.gif";
import pigi from "../components/assets/CTA.png";
import mobile from "../components/assets/instapay.gif";
// import mobileFrame from "../components/assets/mobileFrames.png";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Button } from "react-bootstrap";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import desktopVideo from "../components/assets/horizontal.mp4";
import sliderOneImg from "../components/assets/slider-image-1.jpg";
import sliderTwoImg from "../components/assets/slider-image-2.jpg";
import sliderThreeImg from "../components/assets/slider-image-3.jpg";
import sliderFourImg from "../components/assets/slider-image-4.jpg";
import securityIcon from "../components/assets/pic_01.svg";
import mobileVideo from "../components/assets/vertical.mp4";
import playstore from "../components/assets/google-play-badge.png";
// import googlePlay from "../components/assets/googlePlay.svg";
import pigim from "../components/assets/CTAMobile.png";

const Home = () => {
  const [count, setCount] = useState(1000);
  useEffect(() => {
    let interval;

    const startCounter = () => {
      interval = setInterval(() => {
        if (count > 9.0) {
          setCount((prevCount) => Math.max(prevCount - 8.3, 9.0));
        } else {
          clearInterval(interval);
          setTimeout(() => {
            setCount(1000);
            startCounter(); // Restart the counter after waiting for 5 seconds
          }, 5000); // Wait for 5 seconds before resetting to 1000
        }
      }, 30); // Adjust the interval as needed for the desired speed
    };

    startCounter();

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [count]); // Dependency on count to re-run the effect when count changes
  const handleContactUsClick = () => {
    window.location.href = "mailto:signup@instape.com";
  };
  const handleDownloadButton = () => {
    window.location.href =
      "https://play.google.com/store/apps/details?id=com.instape";
  };
  return (
    <>
      <div>
        <div style={{ position: "relative" }}>
          {/* <div className="desktopVideo">
            <video
              autoPlay
              loop
              muted
              style={{
                width: "100%",
                height: "650px",
                objectFit: "cover",
                background: "rgba(0, 0, 0, 0.5)",
              }}
            >
              <source src={desktopVideo} type="video/mp4" height={80} />
            </video>
          </div>
          <div className="MobileVideo">
            <video
              autoPlay
              loop
              muted
              playsInline
              style={{
                width: "100%",
                height: "80%",
                objectFit: "cover",
                background: "rgba(0, 0, 0, 0.5)",
              }}
            >
              <source src={mobileVideo} type="video/mp4" height={80} />
            </video>
          </div> */}
          {/* SLIDER DESKTOP START */}
          <div className="position-relative w-100">
            <Swiper
              spaceBetween={30}
              centeredSlides={true}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              // pagination={{
              //   clickable: true,
              // }}
              // navigation={true}
              loop={true}
              modules={[Autoplay, Pagination, Navigation]}
              className="myMainSwiper"
            >
              <SwiperSlide>
                <img
                  src={sliderFourImg}
                  className="image-fluid"
                  alt="security-icon"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={sliderTwoImg}
                  className="image-fluid"
                  alt="security-icon"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={sliderThreeImg}
                  className="image-fluid"
                  alt="security-icon"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={sliderOneImg}
                  className="image-fluid"
                  alt="security-icon"
                />
              </SwiperSlide>
            </Swiper>
            <div
              className="position-absolute top-0 start-0 w-100 h-100"
              style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
            ></div>
            <div className="w-100 desktopBannerContent position-absolute top-50 start-50 translate-middle text-center">
              <h1 className="text-white fw-bold display-4 text-shadow">
                Financial Wellbeing.
                <br /> For The Underserved.​
              </h1>
              <p className="text-white fs-5">
                Comprehensive Solutions Across Savings, Loans, Insurance,
                Investments, Health, Etc.
              </p>
            </div>
            <div className="w-100 mobileBannerContent position-absolute top-50 start-50 translate-middle text-center">
              <h5
                style={{ fontSize: 20 }}
                className="text-white fw-bold display-4 text-shadow"
              >
                Financial Wellbeing.
                <br /> For The Underserved.​
              </h5>
              <p className="text-white" style={{ fontSize: 12 }}>
                Comprehensive Solutions Across Savings, Loans, Insurance,
                Investments, Health, Etc.
              </p>
            </div>
          </div>
          {/* SLIDER DESKTOP END */}
          {/* <div
            style={{
              position: "absolute",
              top: -10,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="DesktopEmpower" style={{ textAlign: "center" }}>
              <span className="empower">
                Livelihood Finance.​
                <br />
                For The Underserved.
              </span>
            </div>
            <div className="mobileEmpower" style={{ textAlign: "center" }}>
              <span className="empower">
                Livelihood Finance.​
                <br />
                For The Underserved.
              </span>
            </div>
            <div className="mt-4" style={{ textAlign: "center" }}>
              <span className="grantDesktop">
                Comprehensive Solutions Across Savings, Loans, Insurance,
                Investments, Health, Etc.
              </span>
              <span className="grantMobile">
                Comprehensive Solutions Across Savings, Loans, Insurance,
                Investments, Health, Etc.
              </span>
            </div>
          </div> */}
        </div>

        {/* <div className="mt-4 deskopImg">
          <img src={homeimg} className="img-fluid" alt="Cinque Terre" height="30" />
        </div>
        <div className="mt-4 mobileImg">
          <img src={mobileFrame} className="img-fluid" alt="Cinque Terre" height="30" />
        </div> */}
        <div className="container">
          <div
            className="mt-5 revolutiondesktop"
            style={{ textAlign: "center" }}
          >
            <span className="revolutionText ">
              Revolutionizing Financial Wellbeing<br></br> For Blue/Grey/Pink
              Collar Workers
              {/* Revolutionise Your Workforce’s<br></br> Financial Wellbeing */}
            </span>
          </div>
          <div
            className="mt-4 revolutionMobile"
            style={{ textAlign: "center" }}
          >
            <span className="revolutionText ">
              Revolutionizing Financial Wellbeing For<br></br> Blue/Grey/Pink
              Collar Workers
            </span>
          </div>
          <div className="row mt-5 desktopSwiper">
            <div className="col-md-6 col-lg-3">
              <div
                style={{
                  background:
                    "linear-gradient(180deg, rgba(131, 164, 212, 0.12) 0%, rgba(182, 251, 255, 0.16) 100%), #FFF",
                  padding: 20,
                  borderRadius: "20.045px",
                  height: "350px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div className="row">
                  <span className="cardHeading">The Wellbeing Partner</span>
                  <br />
                  <br />
                  <div>
                    <span className="cardText">
                      InstaPe offers comprehensive solutions to ensure your
                      wellbeing
                    </span>
                  </div>
                </div>
                <div className="d-flex justify-content-end">
                  <img
                    src={mobileAtm}
                    className="img-fluid"
                    alt="Cinque Terre"
                    style={{ width: "50%", height: "150px" }}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div
                style={{
                  background:
                    "linear-gradient(180deg, rgba(97, 144, 232, 0.12) 0%, rgba(167, 191, 232, 0.16) 100%), #FFF",
                  padding: 20,
                  borderRadius: "20.045px",
                  height: "350px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div className="row">
                  <span className="cardHeading">
                    Anytime & Anywhere Instant Access
                  </span>
                  <br />
                  <br />
                  <br />
                  <div>
                    <span className="cardText">
                      InstaPe’s 100% Digital Journey enables instant access to
                      funds 24x7
                    </span>
                  </div>
                </div>
                <div className="d-flex justify-content-end">
                  <img
                    src={payroll}
                    className="img-fluid"
                    alt="Cinque Terre"
                    style={{ width: "50%", height: "150px" }}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 tablet ">
              <div
                style={{
                  background:
                    "linear-gradient(180deg, rgba(5, 117, 230, 0.12) 0%, rgba(2, 27, 121, 0.13) 100%), #FFF",
                  padding: 20,
                  borderRadius: "20.045px",
                  height: "350px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div className="row">
                  <span className="cardHeading">
                    Curated & Customized Solutions
                  </span>
                  <br />
                  <br />
                  <br />
                  <div>
                    <span className="cardText">
                      InstaPe provides solutions that are curated with your
                      wellbeing in mind.
                    </span>
                  </div>
                </div>
                <div className="d-flex justify-content-end align-items-end">
                  <img
                    src={hrPartner}
                    className="img-fluid"
                    alt="Cinque Terre"
                    style={{ width: "50%", height: "150px" }}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 tablet ">
              <div
                style={{
                  background:
                    "linear-gradient(180deg, rgba(31, 162, 255, 0.12) 0%, rgba(18, 216, 250, 0.14) 51.27%, rgba(166, 255, 203, 0.20) 100%), #FFF",
                  padding: 20,
                  borderRadius: "20.045px",
                  height: "350px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div className="row">
                  <span className="cardHeading">
                    Flexible Options, Lesser Burden
                  </span>
                  <br />
                  <br />
                  <br />
                  <div>
                    <span className="cardText">
                      InstaPe’s solutions offer flexible terms at a lower cost
                      to reduce burden
                    </span>
                  </div>
                </div>
                <div className="d-flex justify-content-end align-items-end">
                  <img
                    src={funds}
                    className="img-fluid"
                    alt="Cinque Terre"
                    style={{ width: "50%", height: "150px" }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="mobileSwiper mt-4">
            <Swiper
              spaceBetween={30}
              centeredSlides={true}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              pagination={{
                clickable: true,
              }}
              modules={[Autoplay, Pagination]}
              className="mySwiper"
            >
              <SwiperSlide>
                <div
                  style={{
                    background:
                      "linear-gradient(180deg, rgba(131, 164, 212, 0.12) 0%, rgba(182, 251, 255, 0.16) 100%), #FFF",
                    padding: 20,
                    borderRadius: "20.045px",
                    height: "350px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div className="row">
                    <span className="cardHeading">The Wellbeing Partner</span>
                    <br />
                    <br />
                    <div>
                      <span className="cardText">
                        InstaPe offers comprehensive solutions to ensure your
                        wellbeing
                      </span>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end">
                    <img
                      src={mobileAtm}
                      className="img-fluid"
                      alt="Cinque Terre"
                      style={{ width: "50%", height: "150px" }}
                    />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  style={{
                    background:
                      "linear-gradient(180deg, rgba(97, 144, 232, 0.12) 0%, rgba(167, 191, 232, 0.16) 100%), #FFF",
                    padding: 20,
                    borderRadius: "20.045px",
                    height: "350px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div className="row">
                    <span className="cardHeading">
                      Anytime & Anywhere Instant Access
                    </span>
                    <br />
                    <br />
                    <br />
                    <div>
                      <span className="cardText">
                        InstaPe’s 100% Digital Journey enables instant access to
                        funds 24x7
                      </span>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end">
                    <img
                      src={payroll}
                      className="img-fluid"
                      alt="Cinque Terre"
                      style={{ width: "50%", height: "150px" }}
                    />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  style={{
                    background:
                      "linear-gradient(180deg, rgba(5, 117, 230, 0.12) 0%, rgba(2, 27, 121, 0.13) 100%), #FFF",
                    padding: 20,
                    borderRadius: "20.045px",
                    height: "350px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div className="row">
                    <span className="cardHeading">
                      Curated & Customized Solutions
                    </span>
                    <br />
                    <br />
                    <br />
                    <div>
                      <span className="cardText">
                        InstaPe provides solutions that are curated with your
                        wellbeing in mind.
                      </span>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end align-items-end">
                    <img
                      src={hrPartner}
                      className="img-fluid"
                      alt="Cinque Terre"
                      style={{ width: "50%", height: "150px" }}
                    />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  style={{
                    background:
                      "linear-gradient(180deg, rgba(31, 162, 255, 0.12) 0%, rgba(18, 216, 250, 0.14) 51.27%, rgba(166, 255, 203, 0.20) 100%), #FFF",
                    padding: 20,
                    borderRadius: "20.045px",
                    height: "350px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div className="row">
                    <span className="cardHeading">
                      Flexible Options, Lesser Burden
                    </span>
                    <br />
                    <br />
                    <br />
                    <div>
                      <span className="cardText">
                        InstaPe’s solutions offer flexible terms at a lower cost
                        to reduce burden
                      </span>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end align-items-end">
                    <img
                      src={funds}
                      className="img-fluid"
                      alt="Cinque Terre"
                      style={{ width: "50%", height: "150px" }}
                    />
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>

        {/* COST COUNTER DESKTOP START */}
        {/* <div
          className="bgImage container text-center"
          style={{ position: "relative" }}
        >
          <img src={pigi} className="img-fluid imgRupees" alt="Cinque Terre" />
          <div
            className="overlay-text"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              className="col-md-12 d-flex flex-column mb-4"
              style={{ justifyContent: "space-between" }}
            >
              <span className="counterText">₹ {count.toFixed(2)}*</span>
              <span className="costText">
                Cost for Rs. 1,000 for
                <br />
                10 days!!
              </span>
              <span className="unbeatableText mt-2">
                Unbeatable costs compared to the Rs. 30 to 55 charged by others.
              </span>
            </div>
            <span
              style={{
                position: "absolute",
                bottom: 10,
                right: "15%",
                fontSize: 14,
                fontStyle: "italic",
                color: "lightblue",
              }}
            >
              * Subject to lender's approval
            </span>
          </div>
        </div> */}
        {/* COST COUNTER DESKTOP END*/}

        {/* COST COUNTER MOBILE START */}
        {/* <div
          className="bgImagem text-center mt-5"
          style={{ position: "relative" }}
        >
          <img
            src={pigim}
            className="img-fluid imgRupees"
            style={{ width: "100%" }}
            alt="Cinque Terre"
          />
          <div
            className="overlay-text"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="col-md-12 d-flex flex-column text-center ">
              <span className="counterText">₹ {count.toFixed(2)}*</span>
              <span className="costText">
                Cost for Rs. 1,000 for
                <br />
                10 days!!
              </span>
              <span className="unbeatableText mt-2">
                Unbeatable costs compared to the Rs.<br></br>30 to 55 charged by
                others.
              </span>
              <span
                style={{
                  textAlign: "center",
                  position: "absolute",
                  bottom: 10,
                  left: 0,
                  right: 0,
                  fontSize: 12,
                  fontStyle: "italic",
                  color: "lightblue",
                }}
              >
                * Subject to lenders's approval
              </span>
            </div>
          </div>
        </div> */}
        {/* COST COUNTER MOBILE END */}

        {/* SECURITY AND PRIVACY DESKTOP START */}
        <div
          style={{ background: "#f2fbfc" }}
          className="securityAndPrivaryDesktop my-5 py-5"
        >
          <div className="container d-flex justify-content-around align-items-center">
            <div className="securityIconDiv">
              <img
                src={securityIcon}
                style={{ width: 200 }}
                alt="security-icon"
              />
            </div>
            <div className="mainContentDiv px-3">
              <h2 className="mb-4 fw-bold">Security & Privacy</h2>
              <h4 className="mb-4 fw-bold">
                Trust is Key. Protecting Your Data is Our Priority.
              </h4>
              <p style={{ textAlign: "justify" }}>
                At InstaPe, we prioritize the security and privacy of your
                personal data. With industry-leading certifications and a
                dedicated approach to safeguarding your information, we ensure
                your data remains secure and private at all times.
              </p>
            </div>
            <div className="listDiv fw-bold ps-5">
              <ul className="ps-4 m-0">
                <li>
                  <h5 className="fw-bold">ISO 27001 Certified</h5>
                </li>
                <li>
                  <h5 className="fw-bold">VAPT Cert-In Compliant</h5>
                </li>
                <li>
                  <h5 className="fw-bold">
                    Dedicated Information Security Team
                  </h5>
                </li>
                <li>
                  <h5 className="fw-bold">End-to-End Encryption</h5>
                </li>
                <li>
                  <h5 className="mb-4 fw-bold">Robust Cloud Security</h5>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* SECURITY AND PRIVACY DESKTOP END */}

        {/* SECURITY AND MOBILE START */}
        <div
          style={{ background: "#f2fbfc" }}
          className="securityAndPrivaryMobile my-5 py-5"
        >
          <div className="container">
            <div className="px-3">
              <h2 className="mb-3 fw-bold">Security & Privacy</h2>
              <h4 className="mb-3 fw-bold">
                Trust is Key. Protecting Your Data is Our Priority.
              </h4>
              <p>
                At InstaPe, we prioritize the security and privacy of your
                personal data. With industry-leading certifications and a
                dedicated approach to safeguarding your information, we ensure
                your data remains secure and private at all times.
              </p>
            </div>
            <div className="fw-bold d-flex">
              <ul style={{ fontSize: 14 }}>
                <li>ISO 27001 Certified</li>
                <li>VAPT Cert-In Compliant</li>
                <li>Dedicated Information Security Team</li>
                <li>End-to-End Encryption</li>
                <li>Robust Cloud Security</li>
              </ul>
              <div>
                <img
                  src={securityIcon}
                  style={{ width: 100 }}
                  alt="security-icon"
                />
              </div>
            </div>
          </div>
        </div>
        {/* SECURITY AND MOBILE END */}
        <div className="container pt-5 pb-5 desktopFooter">
          <div className="d-flex justify-content-between row">
            <div className="col-md-5">
              <img
                src={mobile}
                className="img-fluid"
                style={{ height: "500px" }}
                alt="Cinque Terre"
              />
            </div>
            <div className="col-md-7">
              <div className="mt-2 simplyFyLaout d-flex flex-column justify-content-center h-100">
                <span className="unlockFunds">
                  Get In Touch - If You Would Like To Provide Financial
                  Wellbeing To Your Employees, Boost Morale & Reduce Attrition!
                </span>
                <div className="byeText mt-5">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                    }}
                  >
                    {/* <div className="mt-3">
                      <Button
                        onClick={handleDownloadButton}
                        style={{
                          background: "none",
                          border: "none",
                          padding: 0,
                        }}
                        className="downloadNow "
                      >
                        <img
                          src={playstore}
                          style={{ width: 200 }}
                          alt="Cinque Terre"
                        />
                      </Button>
                    </div> */}
                    <div
                      style={{
                        flexDirection: "column",
                        display: "flex",
                      }}
                    >
                      <span style={{ fontSize: 18 }}>
                        <b>Contact Us:</b>
                      </span>
                      <button
                        className="btn p-0"
                        style={{ outline: "none" }}
                        onClick={handleContactUsClick}
                      >
                        signup@instape.com
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container mobileFooter pb-5">
          <div className="d-flex justify-content-between row">
            <div className="col-md-6 mt-3">
              {/* <div className="mt-5 simplyFyLaout ">
              <span className="simplyfy">Simplify. Empower. Thrive. Build.</span>
            </div> */}
              <div className="mt-2 simplyFyLaout">
                <span className="unlockFunds">
                  Get In Touch - If You Would Like To Provide Financial
                  Wellbeing To Your Employees, Boost Morale & Reduce Attrition!
                </span>
              </div>
            </div>
            <div
              className="col-md-6"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                marginTop: 30,
                height: "100%",
              }}
            >
              <div>
                <img
                  src={mobile}
                  className="img-fluid mobileImgFooter"
                  alt="Cinque Terre"
                />
              </div>
              <div className="byeText mt-5">
                {/* <span className="goodbye">
                  Say goodbye to waiting and hello to financial flexibility.
                </span> */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 10,
                  }}
                >
                  {/* <div className="mt-3">
                    <Button
                      onClick={handleDownloadButton}
                      style={{ background: "none", border: "none", padding: 0 }}
                      className="downloadNow "
                    >
                      <img
                        src={playstore}
                        style={{ width: 180 }}
                        alt="Cinque Terre"
                      />
                    </Button>
                  </div> */}
                  <div
                    style={{
                      flexDirection: "column",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ fontSize: 18 }}>
                      <b>Contact Us:</b>
                    </span>
                    <span onClick={handleContactUsClick}>
                      signup@instape.com
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Home;
